import _shared from "../internals/shared";
import _uid from "../internals/uid";
var exports = {};
var shared = _shared;
var uid = _uid;
var keys = shared("keys");
exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};
export default exports;